<template>
  <div class="whole">
    <div class="search">
      <el-form :inline="true">
        <el-form-item>
          <el-button type="primary" class="el-icon-plus" v-popover:popover>{{ $t("button.Add the information of Data") }}</el-button>
        </el-form-item>
        <!--   添加数据的弹窗     -->
        <el-popover
            ref="popover"
            placement="bottom"
            width="1100"
            border
            trigger="click">
          <el-form :inline="true">
            <el-form-item>
              <el-select v-model="addValueYear" :placeholder="$t('placeholder.Year2')" @change="indexSearch(addValueYear,1)">
                <el-option
                    v-for="item in optionsYear"
                    :key="item.value"
                    :label="item.label"
                    :value="item.label">
                </el-option>
              </el-select>
            </el-form-item>
            <!--   这是该年份下的指标     -->
            <el-form-item>
              <el-cascader
                  clearable
                  filterable
                  :placeholder="$t('placeholder.Index2')"
                  :props="{checkStrictly: true}"
                  :options="optionsIndex"
                  v-model="addValueIndex">
              </el-cascader>
            </el-form-item>
<!--            <el-form-item>-->
<!--              <el-select v-if="isLanguage" v-model="addValueIndex" :placeholder="$t('placeholder.Index2')">-->
<!--                <el-option-->
<!--                    v-for="item in optionsIndex"-->
<!--                    :key="item.id"-->
<!--                    :label="item.name_cn"-->
<!--                    :value="item.id">-->
<!--                </el-option>-->
<!--              </el-select>-->

<!--              <el-select v-if="!isLanguage" v-model="addValueIndex" :placeholder="$t('placeholder.Index')">-->
<!--                <el-option-->
<!--                    v-for="item in optionsIndex"-->
<!--                    :key="item.id"-->
<!--                    :label="item.name_en"-->
<!--                    :value="item.id">-->
<!--                </el-option>-->
<!--              </el-select>-->
<!--            </el-form-item>-->


            <el-form-item>
              <el-cascader
                  clearable
                  :placeholder="$t('placeholder.City')"
                  :options="optionsCity"
                  v-model="addValueCity"
              ></el-cascader>
            </el-form-item>

            <el-form-item>
              <el-input v-model="addValue" :placeholder="$t('placeholder.Index3')"></el-input>
            </el-form-item>
            <el-form-item>
              <el-input v-model="addScore" :placeholder="$t('placeholder.Index4')"></el-input>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="addData(addValueIndex,addValueCity,addValue,addScore)">{{ $t("button.Add") }}</el-button>
            </el-form-item>
          </el-form>
        </el-popover>

        <el-form-item>
          <el-select v-model="valueYear" multiple :placeholder="$t('placeholder.Year1')" collapse-tags clearable filterable @change="indexSearch(valueYear,2)">
            <el-option
                v-for="item in optionsYear"
                :key="item.value"
                :label="item.label"
                :value="item.label">
            </el-option>
          </el-select>
        </el-form-item>

        <!--   这是该年份下的指标     -->
        <el-form-item>
          <el-cascader
              collapse-tags
              clearable
              filterable
              :placeholder="$t('placeholder.Index1')"
              :props="{checkStrictly: true,multiple: true}"
              :options="optionsIndex"
              v-model="valueIndex">
          </el-cascader>
        </el-form-item>
<!--        <el-form-item>-->
<!--          <el-select v-if="isLanguage" v-model="valueIndex" multiple collapse-tags clearable filterable :placeholder="$t('placeholder.Index1')" style="width: 250px">-->
<!--            <el-option-->
<!--                v-for="item in optionsIndex"-->
<!--                :key="item.id"-->
<!--                :label="item.name_cn"-->
<!--                :value="item.id">-->
<!--            </el-option>-->
<!--          </el-select>-->

<!--          <el-select v-if="!isLanguage" v-model="valueIndex" multiple collapse-tags clearable filterable :placeholder="$t('placeholder.Index1')" style="width: 250px">-->
<!--            <el-option-->
<!--                v-for="item in optionsIndex"-->
<!--                :key="item.id"-->
<!--                :label="item.name_en"-->
<!--                :value="item.id">-->
<!--            </el-option>-->
<!--          </el-select>-->
<!--        </el-form-item>-->

        <el-form-item>
          <el-cascader
              collapse-tags
              clearable
              filterable
              :placeholder="$t('placeholder.City4')"
              :options="optionsCity"
              :props="{multiple: true}"
              v-model="valueCity"
              style="width: 250px"
          ></el-cascader>
        </el-form-item>

        <el-form-item>
          <el-button type="primary" @click="dataSearch(valueIndex,valueCity)">{{ $t("button.Search") }}</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div class="table">
      <el-table
          v-if="refresh"
          :data="detailData.slice((currentPage-1)*pagesize,currentPage*pagesize)"
          :header-cell-style="{'text-align':'center'}"
          :cell-style="{'text-align':'center'}"
          border
          style="width: 100%">

        <el-table-column prop="indexYear" :label="$t('label.IndexYear')">
          <template v-slot="scope">
            <input type="text" v-model="scope.row.indexYear" v-show=false />
            <span v-show=true>{{scope.row.indexYear}}</span>
          </template>
        </el-table-column>

        <el-table-column prop="cityName" :label="$t('label.CityName')">
          <template v-slot="scope">
            <input type="text" v-model="scope.row.cityName" v-show=false />
            <span v-show=true>{{scope.row.cityName}}</span>
          </template>
        </el-table-column>

        <el-table-column prop="indexName" :label="$t('label.IndexName')">
          <template v-slot="scope">
            <input type="text" v-model="scope.row.indexName" v-show=false />
            <span v-show=true>{{scope.row.indexName}}</span>
          </template>
        </el-table-column>

        <el-table-column prop="indexValue" :label="$t('label.Value')">
          <template v-slot="scope">
            <input type="text" v-model="scope.row.indexValue" v-show="scope.row.iseditor"/>
            <span v-show="!scope.row.iseditor">{{scope.row.indexValue}}</span>
          </template>
        </el-table-column>

        <el-table-column prop="score" :label="$t('label.Score')">
          <template v-slot="scope">
            <input type="text" v-model="scope.row.score" v-show="scope.row.iseditor"/>
            <span v-show="!scope.row.iseditor">{{scope.row.score}}</span>
          </template>
        </el-table-column>

        <el-table-column fixed="right" :label="$t('label.Operation')" width="200">
          <template v-slot="scope">
            <el-button class="el-icon-edit"  @click="edit(scope.row)" type="text" size="small">{{$t("button.Edit")}}</el-button>
            <el-button class="el-icon-check" @click="save(scope.row)" type="text" size="small">{{$t("button.Save")}}</el-button>
            <el-button class="el-icon-delete" @click="handleDelete(scope.row)" type="text" size="small">{{$t("button.Delete")}}</el-button>
          </template>
        </el-table-column>

        <template slot="empty">
            <p>{{$t("label.empty")}}</p>
        </template>
      </el-table>
    </div>

    <div class="pagination">
      <el-pagination
          background
          layout="prev, pager, next"
          @current-change="current_change"
          :page-size="pagesize"
          :total="detailData.length">
      </el-pagination>
    </div>

  </div>
</template>

<script>
import request from "@/utils/request";
export default {
  name: "dataManage",
  data() {
    return {
      refresh:true,
      confirmButtonText:'',
      cancelButtonText:'',
      confirmMessage:'',
      confirmMessage1:'',
      Message1:'',
      title:'',
      isLanguage:'',
      addValueIndex:'',//"添加数据按钮"--要添加数据的指标名称
      addValueYear:'',//"添加数据按钮"--要添加数据的指标年份
      addValueCity:'',//"添加数据按钮"--要添加数据的指标城市
      addValue:'',//"添加数据按钮"--要添加数据的指标值
      addScore:'',//"添加数据按钮"--要添加数据的指标分数

      detailData:[],//存储搜索后数据的列表
      optionsYear: [],//"年份"下拉列表
      optionsCity: [],//"城市"下拉列表
      optionsIndex: [],//"指标"下拉列表

      valueYear: [],//选中年份的列表
      valueCity: [],//选中城市的列表
      valueIndex: [],//选中指标的列表

      pagesize:6,//每页的数据条数
      currentPage:1,//默认开始页面
    }
  },
  methods: {
    //监测当前页面
    current_change:function(currentPage){
      this.currentPage = currentPage;
    },
    //获取指标数据
    indexSearch(valueYear,n){
      this.optionsIndex= []
      this.valueIndex=""
      this.$forceUpdate();
      if(n===1){
        if(valueYear === '2019' || valueYear === '2020'){
          request.get('/dataquery/evaSys?year='+valueYear).then(result => {
            var List = []
            var one={}
            var two={}
            var three={}
            var temp=[]
            var temp1=[]
            var sum={
              label:'',
              value:'',
              children:[]
            }
            if(this.$i18n.locale==='cn'){
              sum.label=result.data[0].name_cn+result.data[0].year
            }
            else{
              sum.label=result.data[0].name_en+result.data[0].year
            }
            sum.value=result.data[0].id
            List = result.data[0].children

            for(let i=0;i<List.length;i++){
              one={
                label:'',
                value:'',
                children:[]
              }
              if(this.$i18n.locale==='cn'){
                one.label = List[i].name_cn
              }
              else{
                one.label = List[i].name_en
              }
              one.value = List[i].id
              temp = List[i].children

              for(let j=0;j<temp.length;j++){
                two={
                  label:'',
                  value:'',
                  children:[]
                }
                if(this.$i18n.locale==='cn'){
                  two.label=temp[j].name_cn
                }
                else{
                  two.label=temp[j].name_en
                }
                two.value=temp[j].id
                one.children.push(two)
                temp1 = temp[j].children

                for(let k=0;k<temp1.length;k++){
                  three = {
                    label:'',
                    value:''
                  }
                  if(this.$i18n.locale==='cn'){
                    three.label = temp1[k].name_cn
                  }
                  else{
                    three.label = temp1[k].name_en
                  }
                  three.value = temp1[k].id
                  two.children.push(three)
                }
              }
              sum.children.push(one)
            }
            this.optionsIndex.push(sum)
            console.log(this.optionsIndex)
          }).catch(err => {
            console.log(err)
          })
        }
        else{
          request.get('/dataquery/evaSys?year='+valueYear).then(result => {
            var List = []
            var one={}
            var two={}
            var temp=[]
            var sum={
              label:'',
              value:'',
              children:[]
            }
            if(this.$i18n.locale==='cn'){
              sum.label=result.data[0].name_cn+result.data[0].year
            }
            else{
              sum.label=result.data[0].name_en+result.data[0].year
            }
            sum.value=result.data[0].id
            List = result.data[0].children

            for(let i=0;i<List.length;i++){
              one={
                label:'',
                value:'',
                children:[]
              }
              if(this.$i18n.locale==='cn'){
                one.label = List[i].name_cn
              }
              else{
                one.label = List[i].name_en
              }
              one.value = List[i].id
              temp = List[i].children
              for(let j=0;j<temp.length;j++){
                two={
                  label:'',
                  value:''
                }
                if(this.$i18n.locale==='cn'){
                  two.label=temp[j].name_cn
                }
                else{
                  two.label=temp[j].name_en
                }
                two.value=temp[j].id
                one.children.push(two)
              }
              sum.children.push(one)
            }
            this.optionsIndex.push(sum)
          }).catch(err => {
            console.log(err)
          })
        }
      }
      if(n===2){
        for(let i=0;i<valueYear.length;i++){
          if(valueYear[i] === '2019' || valueYear[i] === '2020'){
            request.get('/dataquery/evaSys?year='+valueYear[i]).then(result => {
              var List = []
              var one={}
              var two={}
              var three={}
              var temp=[]
              var temp1=[]
              var sum={
                label:'',
                value:'',
                children:[]
              }
              if(this.$i18n.locale==='cn'){
                sum.label=result.data[0].name_cn+result.data[0].year
              }
              else{
                sum.label=result.data[0].name_en+result.data[0].year
              }
              sum.value=result.data[0].id
              List = result.data[0].children

              for(let i=0;i<List.length;i++){
                one={
                  label:'',
                  value:'',
                  children:[]
                }
                if(this.$i18n.locale==='cn'){
                  one.label = List[i].name_cn
                }
                else{
                  one.label = List[i].name_en
                }
                one.value = List[i].id
                temp = List[i].children

                for(let j=0;j<temp.length;j++){
                  two={
                    label:'',
                    value:'',
                    children:[]
                  }
                  if(this.$i18n.locale==='cn'){
                    two.label=temp[j].name_cn
                  }
                  else{
                    two.label=temp[j].name_en
                  }
                  two.value=temp[j].id
                  one.children.push(two)
                  temp1 = temp[j].children

                  for(let k=0;k<temp1.length;k++){
                    three = {
                      label:'',
                      value:''
                    }
                    if(this.$i18n.locale==='cn'){
                      three.label = temp1[k].name_cn
                    }
                    else{
                      three.label = temp1[k].name_en
                    }
                    three.value = temp1[k].id
                    two.children.push(three)
                  }
                }
                sum.children.push(one)
              }
              this.optionsIndex.push(sum)
              console.log(this.optionsIndex)
            }).catch(err => {
              console.log(err)
            })
          }
          else{
            request.get('/dataquery/evaSys?year='+valueYear[i]).then(result => {
              var List = []
              var one={}
              var two={}
              var temp=[]
              var sum={
                label:'',
                value:'',
                children:[]
              }
              if(this.$i18n.locale==='cn'){
                sum.label=result.data[0].name_cn+result.data[0].year
              }
              else{
                sum.label=result.data[0].name_en+result.data[0].year
              }
              sum.value=result.data[0].id
              List = result.data[0].children

              for(let i=0;i<List.length;i++){
                one={
                  label:'',
                  value:'',
                  children:[]
                }
                if(this.$i18n.locale==='cn'){
                  one.label = List[i].name_cn
                }
                else{
                  one.label = List[i].name_en
                }
                one.value = List[i].id
                temp = List[i].children
                for(let j=0;j<temp.length;j++){
                  two={
                    label:'',
                    value:''
                  }
                  if(this.$i18n.locale==='cn'){
                    two.label=temp[j].name_cn
                  }
                  else{
                    two.label=temp[j].name_en
                  }
                  two.value=temp[j].id
                  one.children.push(two)
                }
                sum.children.push(one)
              }
              this.optionsIndex.push(sum)
            }).catch(err => {
              console.log(err)
            })
          }
        }
      }

    },
    //实现搜索按钮
    dataSearch(valueIndex,valueCity){
      this.detailData=[]
      var tempDetail=[]
      var indexString
      var dict={}
      var that=this
      //两层循环：多个指标和多个城市
      for(let i=0;i<valueIndex.length;i++){
        for(let j=0;j<valueCity.length;j++){
          //内层循环把指标id放在一起
          var ind=valueIndex[i].length-1
          indexString="&eva_indexsId="+valueIndex[i][ind]
          request.get('/dataquery/detail?citiesId='+valueCity[j][2]+indexString).then(result => {
            console.log(result)
            result.data.forEach(function (e) {
              dict={}
              dict.cityId=e.city.id
              dict.indexId=e.eva_index.id
              dict.indexYear=e.eva_index.year
              if(that.isLanguage===true){
                dict.cityName=e.city.name_cn
                dict.indexName=e.eva_index.name_cn
              }
              else{
                dict.cityName=e.city.name_en
                dict.indexName=e.eva_index.name_en
              }
              dict.score=e.score
              dict.source=e.source
              if(e.value==null){
                dict.indexValue=0
              }
              else{dict.indexValue=e.value}
              dict.iseditor = false;
              tempDetail.push(dict)
            })
            that.detailData=tempDetail
          }).catch(err => {
            console.log(err)
          })
        }
      }
    },
    //编辑数据信息
    edit(row) {
      row.iseditor =true;
    },
    //保存修改后的数据信息，上传至数据库
    save(row) {
      row.iseditor = false;
      var that=this
      that.$confirm(that.confirmMessage, that.title, {
        confirmButtonText: that.confirmButtonText,
        cancelButtonText: that.cancelButtonText,
        type: 'warning'
      }).then(() => {
        request.put("/cidata?city_id="+row.cityId+"&eva_index_id="+row.indexId+"&score="+row.score+"&value="+row.indexValue+"&source="+row.source).then(successResponse => {
          if (successResponse.data === true) {
            that.dataSearch(that.valueIndex,that.valueCity)
            if(that.isLanguage===true){
              alert("数据信息修改成功！")
            }
            else{
              alert("Data information modified successfully！")
            }
          }else{
            if(that.isLanguage===true){
              alert("数据信息修改失败！")
            }
            else{
              alert("Failed to modify data information！")
            }
            that.dataSearch(that.valueIndex,that.valueCity)
          }
        }).catch(err => {
          if(that.isLanguage===true){
            alert("申请修改失败，请稍后重试！");
          }
          else{
            alert("Failed to apply for modification, please try again later!")
          }
          console.log(err);
        })
      })
    },
    //删除数据信息
    handleDelete(row) {
      var that=this
      that.$confirm(that.confirmMessage1, that.title, {
        confirmButtonText: that.confirmButtonText,
        cancelButtonText: that.cancelButtonText,
        type: 'warning'
      }).then(() => {
        request.delete("/cidata?city_id="+row.cityId+"&eva_index_id="+row.indexId).then(successResponse => {
          if (successResponse.data === true) {
            if(that.isLanguage===true){
              alert("数据删除成功！")
            }
            else{
              alert("Delete successfully！")
            }
            that.dataSearch(that.valueIndex,that.valueCity)
          } else {
            if(that.isLanguage===true){
              alert("数据删除失败！")
            }
            else{
              alert("Failed to delete！")
            }
          }
        }).catch(err => {
          if(that.isLanguage===true){
            alert("申请修改失败，请稍后重试！");
          }
          else{
            alert("Failed to apply for modification, please try again later!")
          }
          console.log(err);
        })
      }
      ).catch(() => {
        this.$message({
          type: 'info',
          message: this.Message1
        })
      })
    },
    //获取城市数据---级联选择器
    getCitys(){
      var that=this
      var continent={}
      var country={}
      var city={}
      request.get('/continent').then(async function (res){
        for(let i=0;i<res.data.length;i++){
          let continentItem=res.data[i]
          continent={
            label:'',
            value:'',
            children:[]
          }
          if(that.isLanguage===true){
            continent.label=continentItem.name_cn
          }
          else{
            continent.label=continentItem.name_en
          }
          continent.value=continentItem.id

          //根据洲id获取国家，存在临时country字典中，并push到continent的children列表中
          await request.get('/country?continent_id='+continentItem.id).then(async function (res1){
            for(let j=0;j<res1.data.length;j++){
              let countryItem=res1.data[j]
              country={
                label:'',
                value:'',
                children:[]
              }
              if(that.isLanguage===true){
                country.label=countryItem.name_cn
              }
              else{
                country.label=countryItem.name_en
              }
              country.value=countryItem.id
              //根据国家id获取城市，存在临时city字典中，并push到country的children列表中
              await request.get('city?country_id='+countryItem.id).then(function (res2){
                for(let k=0;k<res2.data.length;k++){
                  let cityItem=res2.data[k]
                  city={
                    label:'',
                    value:'',
                  }
                  if(that.isLanguage===true){
                    city.label=cityItem.name_cn
                  }
                  else{
                    city.label=cityItem.name_en
                  }
                  city.value=cityItem.id
                  country.children.push(city)
                }
                continent.children.push(country)
              }).catch(function (err2){
                console.log(err2)
              })
            }
          }).catch(function (err1){
            console.log(err1)
          })
          that.optionsCity.push(continent)
        }
      }).catch(function (err){
        console.log(err)
      })
    },
    //添加指标
    addData(addValueIndex,addValueCity,addValue,addScore){
      var that=this
      var ind=addValueIndex.length-1
      request.post("/cidata?city_id="+addValueCity[2]+"&eva_index_id="+addValueIndex[ind]+"&score="+addScore+"&value="+addValue).then(function (result){
        if(result.data===true){
          if(that.isLanguage===true){alert("添加数据成功！")}
          else{alert("Data added successfully!")}
          that.addValueIndex=''
          that.addValueCity=''
          that.addValue=''
          that.addScore=''
        }
        else{
          if(that.isLanguage===true){alert("添加数据失败！已存在该数据信息")}
          else{alert("Failed to add data! The data information already exists")}
        }
      })
    }
  },
  //页面创建的时候，获取该用户拥有年份的权限+获取城市列表
  mounted() {
    this.optionsYear= JSON.parse(window.sessionStorage.getItem('years'))
    this.getCitys()
  },
  watch:{
    detailData:{
      handler(){
        this.refresh=false
        this.$nextTick(()=>{
          this.refresh=true
        })
      }
    }
  },
  created() {
    if(this.$i18n.locale==='cn'){
      this.isLanguage=true
      this.confirmButtonText='确定'
      this.cancelButtonText='取消'
      this.confirmMessage='此操作将修改该数据'
      this.confirmMessage1='此操作将永久删除此数据，是否要继续？'
      this.Message1='已取消删除'
      this.title='提示'
    }
    else{
      this.isLanguage=false
      this.confirmButtonText='Confirm'
      this.cancelButtonText='Cancel'
      this.confirmMessage='This operation will modify the data'
      this.confirmMessage1='This operation will permanently delete this data. Do you want to continue?'
      this.Message1='Deletion cancelled'
      this.title='tip'
    }
  }
}
</script>

<style scoped>
@import "~@/assets/css/sameCss.css";
</style>